<template>
  <div class="introduce">
    <!-- 导航banner -->
    <div class="banner" id="banner">
      <!--<div class="banner_content">-->
        <!--<div class="swiper-container swiper1">-->
          <!--<div class="swiper-wrapper">-->
            <!--<div class="swiper-slide">-->
              <!---->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="pagination swiper1pagination"></div>-->
        <!--</div>-->
      <!--</div>-->
      <img src="../../../assets/images/front/banner5.png" alt="">
    </div>
    <router-view></router-view>
  </div>
</template>
<script type="text/babel">

//  import Swiper from 'swiper';
//  import 'swiper/dist/css/swiper.min.css';

  export default {
    components: {
    },
    data: function() {
      return {
      };
    },
    name: 'introduce',
    mounted() {
//      let mySwiper = new Swiper('.swiper1',{
//        loop: true,
//        autoplay: 3000,
//        pagination : '.swiper1pagination',
//        paginationClickable :true,
//        resizeReInit : true,
//      });
    },
    methods: {

    }
  }
</script>
<style>
  /*.introduce .pagination {*/
    /*position: absolute;*/
    /*z-index: 20;*/
    /*bottom: 20px !important;*/
    /*width: 100%;*/
    /*text-align: center;*/
  /*}*/
  /*.introduce .swiper-pagination-switch {*/
    /*display: inline-block;*/
    /*width:40px;*/
    /*height:20px;*/
    /*background:url(../../../assets/images/front/banner_fyq.png) center center no-repeat;*/
    /*display: inline-block;*/
    /*margin-left: 38px;*/
    /*cursor: pointer;*/
  /*}*/
  /*.introduce .swiper-pagination-switch {*/
    /*display: inline-block;*/
    /*width:40px;*/
    /*height:20px;*/
    /*background:url(../../../assets/images/front/banner_fyq.png) center center no-repeat;*/
    /*display: inline-block;*/
    /*margin-left: 38px;*/
    /*cursor: pointer;*/
  /*}*/
  /*.introduce .swiper-active-switch {*/
    /*background: url(../../../assets/images/front/banner_fyq_active.gif) center center no-repeat;*/
  /*}*/

  /*.introduce .swiper1 .swiper-pagination-bullet{*/
    /*display: inline-block;*/
    /*width:40px !important;*/
    /*height:20px !important;*/
    /*background:url(../../../assets/images/front/banner_fyq.png) center center no-repeat !important;*/
    /*margin-left: 38px !important;*/
    /*cursor: pointer;*/
  /*}*/
  /*.introduce .swiper1 .swiper-pagination-bullet-active {*/
    /*background: url(../../../assets/images/front/banner_fyq_active.gif) center center no-repeat !important;*/
  /*}*/

  /*.introduce .swiper-pagination1{*/
    /*margin-top: 39px;*/
    /*text-align: center;*/
    /*left: 600px;*/
  /*}*/
  /*.introduce .swiper-pagination1 .swiper-pagination-bullet{*/
    /*width:8px;*/
    /*height:8px;*/
    /*border: 1px solid rgba(63,63,63,1);*/
    /*border-radius:50%;*/
    /*display: inline-block;*/
    /*margin-left: 10px;*/
    /*cursor: pointer;*/
    /*background: white;*/
  /*}*/
  /*.introduce .swiper-pagination1 .swiper-pagination-bullet-active{*/
    /*background:rgba(204,204,204,1);*/
    /*border: 1px solid rgba(204,204,204,1);*/
  /*}*/

  .introduce .banner img{
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/pages/front/introduce/index.vue